import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import contcactsIcon from "./assets/contactsIcon.svg";
import iconSeguimiento from "./assets/iconSeguimiento.svg";
import iconClientes from "./assets/iconClientes.svg";
import iconPromotores from "./assets/iconPromotores.svg";
import iconAsesor from "./assets/iconAsesor.svg";
import iconCotizador from "./assets/iconCotizador.svg";
import iconAgenda from "./assets/iconAgenda.svg";
import iconSetting from "./assets/iconSetting.svg";


const ButtonMenu = ({activeButton, setActiveButton}) => {
  return (
    <ButtonGrid>
      <Button
        size="large"
        active={activeButton === 'contactos'}
        onClick={() => setActiveButton('contactos')}
      >
        <img src={contcactsIcon} alt="CONTACTOS" />
        CONTACTOS
      </Button>
      <Button
        size="small"
        active={activeButton === 'seguimientos'}
        onClick={() => setActiveButton('seguimientos')}
      >
        <img src={iconSeguimiento} alt="SEGUIMIENTOS" />
        SEGUIMIENTOS
      </Button>
      <Button
        size="small"
        active={activeButton === 'clientes'}
        onClick={() => setActiveButton('clientes')}
      >
        <img src={iconClientes} alt="CLIENTES" />
        CLIENTES
      </Button>
      <Button
        size="large"
        active={activeButton === 'productores'}
        onClick={() => setActiveButton('productores')}
      >
        <img src={iconPromotores} alt="PRODUCTORES" />
        PRODUCTORES
      </Button>
      <Button
        size="large"
        active={activeButton === 'asesores'}
        onClick={() => setActiveButton('asesores')}
      >
        <img src={iconAsesor} alt="ASESORES" />
        ASESORES
      </Button>
      <Button
        size="small"
        active={activeButton === 'cotizador'}
        onClick={() => setActiveButton('cotizador')}
      >
        <img src={iconCotizador} alt="COTIZADOR" />
        COTIZADOR
      </Button>
      <Button
        size="small"
        active={activeButton === 'agenda'}
        onClick={() => setActiveButton('agenda')}
      >
        <img src={iconAgenda} alt="AGENDA" />
        AGENDA
      </Button>
      <Button
        size="large"
        active={activeButton === 'preferencias'}
        onClick={() => setActiveButton('preferencias')}
      >
        <img src={iconSetting} alt="PREFERENCIAS" />
        PREFERENCIAS
      </Button>
    </ButtonGrid>
  );
};

export default ButtonMenu;


const ButtonGrid = styled.div`
  display: flex;
  gap: 10px;
  width: 370px;
  flex-wrap: wrap;
`;

const Button = styled.button`
  background-color: ${({ active }) => (active ? '#002c44' : '#ffffff')};
  border: 2px solid #002c44;
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  width: ${({ size }) => (size === 'large' ? '100%' : 'calc(50% - 5px)')};
  display: flex;
  flex-direction: column;
  gap:16px;
  align-items: center;
  justify-content: center;
  color: ${({ active }) => (active ? '#ffffff' : '#002c44')};
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 150% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #002c44;
    color: #ffffff;

    img {
      filter: brightness(0) invert(1); /* Cambia el color del icono a blanco */
    }
  }

  img {
    width: 24px;
    height: 24px;
    filter: ${({ active }) => (active ? 'brightness(0) invert(1);' : 'none')}; 
    transition: filter 0.3s;
  }
`;
